/**
* @Author: wangkai
* @Date: 2018/9/30
* @Last Modified by: wangkai
* @Desc: http相关工具函数
**/
import instance from './axiosConfig';
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import Vue from 'vue';
import {
externalCallFunc
} from '@/utils/webviewUtils';

import Cookies from "js-cookie";

Vue.use(LoadingPlugin);
Vue.use(ToastPlugin);
Vue.use(AlertPlugin);

/**
* 提前定义接口路径，请求方法
* @param url {String} 请求地址
* @param method {String} 请求方式,默认为post
* @returns {} 返回调用接口函数
*/

export const ajaxFunc = (url, method = 'post', isMicroService = 0, header) => (params = {}) => new Promise((resolve, reject) => {
let value;
method.toLowerCase() === 'post' ? value = 'data' : value = 'params';
return instance({
url,
method,
isMicroService,
[value]: params,
header
})
.then(res => resolve(res), err => {
reject(err)
});
});
/**
* 判断本地存储中的token是否存在，从而在请求头中携带
* @returns {string} [返回localStorage中的token,或者返回'']
*/
export const getToken = () => {
let token = sessionStorage.getItem('user_token');
if (!token) {
let userInfo = localStorage.getItem('user');
if (userInfo) {
token = JSON.parse(userInfo).user_token || '';
} else {
token = localStorage.getItem("user_token")
}
}
return token
};


const codeMsg = {
'10000': 'user_token为空',
'10001': '登录信息过期或已失效，请登录！',
'10002': 'user_token不存在 || 超级会员身份失效'
};
/**
* 对错误code进行统一处理：
* @param code {Number} 后端返回的code
*/
export const handleErrorCode = ({
code,
msg
}) => {
if (code === 10000 || code === 10002 || code === 10001) {
localStorage.clear();

externalCallFunc({
funcName: 'finishWeb',
default_func: () => {

let host = window.location.host;
let list = window.location.href.split(host);
if (list.length) {
if (list[1].indexOf('code') === -1) {
localStorage.setItem('fullPathList', list[1]);
}
}
window.location.href = ('/login');
}
})
}

Vue.$vux.toast.text(msg, 'middle');
};

/**
* 删除重复请求：确保前一次的请求发送之后才能再此次发起请求
* @param {Map} requestMap 区分唯一请求的Map对象键值保存对
* @param {Object} config 请求配置项
* @param {Object} qs 将嵌套对象转换为query的工具
* @param {Function} CancelToken 取消请求实例
*/
export const delRepeatHttpRequest = (requestMap, config, qs, CancelToken) => {
const {
url,
method,
data
} = config;
const keyString = qs.stringify(Object.assign({}, {
url,
method
}, data));
if (requestMap.get(keyString)) {

config.cancelToken = new CancelToken((cancel) => {
cancel({
type: 'cancelHttp',
msg: 'Please slow down a little'
});
});
}
requestMap.set(keyString, true);
Object.assign(config, {
_keyString: keyString
});
};



// WEBPACK FOOTER //
// ./src/request/tools.js